import { getFormValues } from 'redux-form';
import { Selector } from 'reselect';
import { RootState } from 'src/react/root/state/RootState';
import { SettingsFormData } from 'src/react/settings/types/SettingsFormData';

export const getSettingsFormValues: Selector<RootState, SettingsFormData | undefined>
    = getFormValues('settings') as any;
